import { convertToGalleryItem } from "./convert-to-gallery-item";
const convertToGalleryItemList = (items, relValue, anchorTarget) => {
  return items.map((item, index) => convertToGalleryItem(item, index, relValue, anchorTarget));
};
export {
  convertToGalleryItemList
};
//# sourceMappingURL=convert-to-gallery-item-list.js.map
